<div class="flex-col height100p">
    @if (allowCreate) {
        <sm-toolbar class="flex-item-fixed">
            <p-button [routerLink]="[_Strings.ensureSuffix(detailUrl, '/') + '0']" severity="success" icon="fas fa-plus-circle" label="Neu"></p-button>
            <ng-container *ngTemplateOutlet="toolbarTemplate"></ng-container>
        </sm-toolbar>
    }
    <sm-table class="flex-item-fill" 
        [data]="data" 
        [floatingFilter]=true
        [allowRemoveRow]="allowDelete" 
        [removeRowWarningMessage]="'Möchten Sie dieses Objekt löschen?'"
        (onRowRemoved)="deleteObject($event)"
        (onRowSelect)="rowSelect($event)"></sm-table>
</div>
